export let BLOCK_PAGE = 'BLOCK_PAGE';
export let UPDATE_INITIAL_STATE = 'UPDATE_INITIAL_STATE';
export let SET_GLOBAL_LOADER = 'SET_GLOBAL_LOADER';
export const MESSAGES_CHUNK_REQUEST = 'MESSAGES_CHUNK_REQUEST';
export const NEW_MESSAGES_CHUNK = 'NEW_MESSAGES_CHUNK';
export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';
export const OPEN_AVAILABLE_CHATS = 'OPEN_AVAILABLE_CHATS';
export const CLOSE_AVAILABLE_CHATS = 'CLOSE_AVAILABLE_CHATS';

export const APP_INITIAL_STATE_REQUEST = 'APP_INITIAL_STATE_REQUEST'
export const APP_INITIAL_STATE_REQUEST_SUCCESS = 'APP_INITIAL_STATE_REQUEST_SUCCESS'
export const APP_INITIAL_STATE_REQUEST_FAILURE = 'APP_INITIAL_STATE_REQUEST_FAILURE'

export const AUTH_REQUEST = 'APP_INITIAL_AUTH_REQUEST'
export const AUTH_REQUEST_SUCCESS = 'AUTH_REQUEST_SUCCESS'
export const AUTH_REQUEST_FAILURE = 'AUTH_REQUEST_FAILURE'

export const CONNECTED_USERS_LIST_UPDATE = 'CONNECTED_USERS_LIST_UPDATE';

export const COMPOSED_MESSAGE_SEND = 'COMPOSED_MESSAGE_SEND';
export const COMPOSED_MESSAGE_SEND_SUCCESS = 'COMPOSED_MESSAGE_SEND_SUCCESS';
export const COMPOSED_MESSAGE_SEND_FAILURE = 'COMPOSED_MESSAGE_SEND_FAILURE';

export const REPORT_REQUEST = 'REPORT_REQUEST';
export const REPORT_REQUEST_SUCCESS = 'REPORT_REQUEST_SUCCESS';
export const REPORT_REQUEST_FAILURE = 'REPORT_REQUEST_FAILURE';

export const COMPOSED_MESSAGE_RECEIVED = 'COMPOSED_MESSAGE_RECEIVED';
export const DIRECT_MESSAGE_RECEIVED = 'DIRECT_MESSAGE_RECEIVED';

export const SWITCH_ROOM = 'SWITCH_ROOM';

export const ROOM_HISTORY_UPDATE = 'ROOM_HISTORY_UPDATE';

export const DIRECT_MESSAGE_OPEN = 'DIRECT_MESSAGE_OPEN';

export const READ_MESSAGES = 'READ_MESSAGES';

export const SEND_WSS_MESSAGE = 'SEND_WSS_MESSAGE';
export const AUTH_DATA_UPDATE = 'AUTH_DATA_UPDATE';

export const CHATROOM_LIST_UPDATE = 'CHATROOM_LIST_UPDATE';
export const UNREAD_MESSAGES_UPDATE = 'UNREAD_MESSAGES_UPDATE';
export const RECENT_CHATS_UPDATE = 'RECENT_CHATS_UPDATE';
export const CHATROOMS_VISIBILITY_FILTER_SET = 'CHATROOMS_VISIBILITY_FILTER_SET';

export const ACCEPT_INVITATION = 'ACCEPT_INVITATION';
export const INVITATIONS_LIST_UPDATE = 'INVITATIONS_LIST_UPDATE';
export const UNSEEN_INVITATIONS_UPDATE = 'UNSEEN_INVITATIONS_UPDATE';
export const INVITATION_DELETE = 'INVITATION_DELETE';

export const ROOM_LEAVE = 'ROOM_LEAVE';
export const GOT_KICKED = 'GOT_KICKED';

export const TOGGLE_CHAT_BLOCK_STATE = 'TOGGLE_CHAT_BLOCK_STATE';
